import { differenceInYears, parseISO } from 'date-fns';

type MinimumAgeValidationProps = {
  ageMinimum: number;
  value?: string;
};

export const minimumAgeValidation = ({
  value,
  ageMinimum,
}: MinimumAgeValidationProps) => {
  if (!value) return false;

  return differenceInYears(new Date(), parseISO(value)) >= ageMinimum;
};
